import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { reportApi } from '../../services/report';

interface ReportState {
  selectedReport: any | null;
  filters: {
    collectionID: string | null;
    moduleID: string | null;
    type: string | null;
    sortBy: string | null;
    sortOrder: 'asc' | 'desc';
  };
  pagination: {
    page: number;
    limit: number;
  };
  isLoading: boolean;
  error: string | null;
}

const initialState: ReportState = {
  selectedReport: null,
  filters: {
    collectionID: null,
    moduleID: null,
    type: null,
    sortBy: null,
    sortOrder: 'desc',
  },
  pagination: {
    page: 1,
    limit: 10,
  },
  isLoading: false,
  error: null,
};

const reportSlice = createSlice({
  name: 'report',
  initialState,
  reducers: {
    setSelectedReport: (state, action: PayloadAction<any | null>) => {
      state.selectedReport = action.payload;
    },
    setFilters: (state, action: PayloadAction<Partial<ReportState['filters']>>) => {
      state.filters = { ...state.filters, ...action.payload };
      state.pagination.page = 1;
    },
    setPagination: (state, action: PayloadAction<Partial<ReportState['pagination']>>) => {
      state.pagination = { ...state.pagination, ...action.payload };
    },
    setLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    clearReport: (state) => {
      state.selectedReport = null;
      state.error = null;
    },
    resetFilters: (state) => {
      state.filters = {
        collectionID: null,
        moduleID: null,
        type: null,
        sortBy: null,
        sortOrder: 'desc',
      };
      state.pagination.page = 1;
    },
  },
  extraReducers: (builder) => {
    builder
      .addMatcher(
        reportApi.endpoints.getReports.matchPending,
        (state) => {
          state.isLoading = true;
          state.error = null;
        }
      )
      .addMatcher(
        reportApi.endpoints.getReports.matchFulfilled,
        (state) => {
          state.isLoading = false;
        }
      )
      .addMatcher(
        reportApi.endpoints.getReports.matchRejected,
        (state, action) => {
          state.isLoading = false;
          state.error = action.error.message || 'Помилка завантаження звітів';
        }
      );
  },
});

export const {
  setSelectedReport,
  setFilters,
  setPagination,
  setLoading,
  setError,
  clearReport,
  resetFilters,
} = reportSlice.actions;

export default reportSlice.reducer; 